import React from 'react';
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import { scaleImage } from '@nykaa/image-utils';
const Root = styled.div `
  position: relative;
  border-radius: ${({ border, theme }) => border || theme.borders.radius20};
  padding: ${({ theme: { spacing } }) => `${spacing.spacing20} ${spacing.spacing40}`};
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  min-height: 36px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  overflow: hidden;
  z-index: 0;
`;
const Title = styled.div `
  ${({ theme }) => theme.typography.subTitleSmall};
  color: ${({ theme, color }) => color || theme.colors.primary40};
`;
Title.displayName = 'Title';
const PriceInfo = styled.div `
  display: flex;
  align-items: baseline;
  ${({ isDifferential, theme }) => (isDifferential ? theme.typography.subTitleSmall : theme.typography.labelMedium)};
  color: ${({ theme, color }) => color || hexToRgb(theme.colors.textPrimary, 0.92)};
`;
PriceInfo.displayName = 'PriceInfo';
const Discount = styled.span `
  ${({ theme }) => theme.typography.labelSmall};
  color: ${({ theme, color }) => color || theme.colors.positive};
  margin-left: ${({ theme }) => theme.spacing.spacing20};
`;
const BackgroundImage = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: -1;
`;
const PriceReveal = ({ prData, listingPriceReveal, isDifferential, }) => {
    const { isActive = false, title: configTitle, styles, } = listingPriceReveal || {};
    const { titleColor: configTitleColor, border: configBorderRadius, spColor: configSpColor, spColor: configBgImg, discountColor: configDiscountColor, } = styles || {};
    const { templateType, text: prTitle, discount, price, textColor, priceColor, discountColor: prDiscountColor, borderRadius, bgColor, } = prData || {};
    const updatedPrData = {
        title: prTitle || configTitle,
        border: (borderRadius && `${borderRadius}px`) || configBorderRadius,
        bgImg: bgColor || configBgImg,
        titleColor: textColor || configTitleColor,
        spColor: priceColor || configSpColor,
        discountColor: prDiscountColor || configDiscountColor,
    };
    const { title, border, bgImg, titleColor, spColor, discountColor, } = updatedPrData;
    const showPrice = !!price && (templateType === 1);
    const { src, srcSet } = scaleImage({
        url: bgImg,
        width: 156,
    });
    if (isActive && (price || templateType)) {
        return (React.createElement(Root, { border: border },
            bgImg && (React.createElement(BackgroundImage, { src: src, srcSet: srcSet })),
            React.createElement(Title, { color: titleColor }, title),
            showPrice && (React.createElement(PriceInfo, { isDifferential: isDifferential, color: spColor },
                "\u20B9",
                price,
                discount ? React.createElement(Discount, { color: discountColor }, discount) : null))));
    }
    return null;
};
export default PriceReveal;
